var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Small } from "syf-component-library/ui/typography";
import { PromoExpirationTooltipTittle } from "../../ui/atoms/Tooltip/Tooltip.style";
var es = {
    labels: {
        accountEndingIn: "Cuenta que termina en",
        loanEndingIn: "Préstamo que termina en",
        addNickName: "Añada un alias al préstamo",
        paymentDueDate: "Fecha de pago",
        totalAmountDue: "Monto Total a Pagar",
        nextAmountMonthlyTooltip: "Incluye toda tarifa y todo monto vencido anterior.",
        nextAmountPN4Tooltip: "Incluye todo el monto vencido anteriormente.",
        nextAmountDue: "Próximo Monto Adeudado",
        totalMinimumPayment: "Total del Pago mínimo",
        noPaymentDue: "No Hay un Pago a Vencer",
        forHelp: "para obtener ayuda.",
        creditLimit: "Límite de Crédito",
        currentBalance: "Saldo Actual",
        totalPaid: "Total Pagado",
        availableToSpend: "Disponible para gastar",
        cardLogo: "Logotipo de la tarjeta",
        loanMaturityDate: "Fecha de vencimiento del préstamo",
        totalLoanBalance: "Saldo Total del Préstamo",
        totalLoanBalanceTooltip: "El Saldo Total del Préstamo puede cambiar por varias razones (por ej. cargos, tarifas, pagos y devoluciones). Si corresponde, el Saldo Total del Préstamo puede aumentar a medida que se cumplen los pedidos.",
        totalLoanBalanceSecuredInstallment: function (_a) {
            var telephoneNumber = _a.telephoneNumber;
            return (_jsxs(_Fragment, { children: ["Este es el saldo del capital restante que a\u00FAn se adeuda por su pr\u00E9stamo; no es el monto requerido para pagar el pr\u00E9stamo en su totalidad. Para obtener una cotizaci\u00F3n actual para la liquidaci\u00F3n llame a nuestro equipo de Atenci\u00F3n al Cliente ", telephoneNumber, "."] }));
        },
        totalRemaining: "Saldo Restante",
        monthlyPayment: " Pago Mensual",
        currentBalanceTooltip: "Podría no reflejar transacciones recientes.",
        unavailable: "No disponible",
        loanAmount: "Monto del préstamo",
        amountFinanced: "Monto Financiado",
        nextScheduledPaymentAmount: "Próximo Monto de Pago Programado",
        nextScheduledPaymentDate: "Próxima Fecha de Pago Programado",
        loanNickNameHeader: "Añada un alias al préstamo",
        loanNickNameAllowedChars: "Por favor, use solo números (0-9) y letras (a-z)",
        loanNickNameNumCountError: "Por favor, no ingrese más de 4 números",
        loanNicknameText: "Añada un alias a este préstamo para una referencia rápida. Por ejemplo: “Remodelación de Cocina” o “Máquina de lavar”.",
        loanNicknameStrongText: "No Incluya información personal o confidencial.",
        makePaymentBtn: "Realizar Pago",
        makeAPaymentBtn: "Realizar un Pago",
        registerAccountBtn: "Registre la cuenta",
        manageYourCreditBalanceBtn: "Administre el Saldo a Su Favor",
        activityBtn: "Actividad",
        detailsBtn: "Detalles",
        statementsBtn: "Estados De Cuenta",
        rewardsBtn: "Recompensas",
        accountServicesBtn: "Servicios de Cuentas",
        promotionsBtn: "Promociones",
        generalError: "Algo salió mal",
        nicknameError: "No podemos actualizar su alias en estos momentos. Por favor, intente nuevamente más tarde.",
        noAccountCard: "No Account Card available.",
        accountNickname: "Alias de Préstamo",
        overlayHeading: "Se requiere su atención.",
        overlayText: "Hay un problema con su cuenta. Llame al servicio de atención al cliente al",
        cardActivationBtn: "Activar la tarjeta",
        totalDue: "Total Adeudado",
        moreBtn: "Más",
        introRateLoanTooltip: function () {
            return (_jsxs(_Fragment, { children: [_jsx(PromoExpirationTooltipTittle, { children: "Este es un pr\u00E9stamo con Tasa de Introducci\u00F3n." }), _jsx(Small, __assign({ isInline: true }, { children: "Su pr\u00E9stamo tiene una tasa de introducci\u00F3n con un pago fijo. Su tasa y monto de pago aumentar\u00E1n cuando finalice el per\u00EDodo de introducci\u00F3n." }))] }));
        },
        beforePromoExpirationTooltip: function (_a) {
            var date = _a.date;
            return (_jsxs(_Fragment, { children: [_jsx(PromoExpirationTooltipTittle, { children: "Este es un Pr\u00E9stamo con Inter\u00E9s Eximido" }), _jsxs(Small, __assign({ isInline: true }, { children: ["Si usted liquida el monto financiado m\u00E1s cualquier tarifas antes de", " ", _jsx(Small, __assign({ isInline: true, weight: "bold" }, { children: date })), ", todos los intereses ser\u00E1n eximidos."] }))] }));
        },
        afterPromoExpirationTooltip: function (_a) {
            var date = _a.date;
            return (_jsxs(_Fragment, { children: [_jsx(PromoExpirationTooltipTittle, { children: "El per\u00EDodo promocional ha finalizado" }), _jsxs(Small, __assign({ isInline: true }, { children: ["El per\u00EDodo promocional para este pr\u00E9stamo finaliz\u00F3 el", " ", _jsx(Small, __assign({ isInline: true, weight: "bold" }, { children: date })), "."] }))] }));
        },
        loanPaidOffOverlayHeading: "¡Felicitaciones!",
        loanPaidOffOverlayText: "El préstamo está saldado.",
    },
    autopay: {
        text: "Pago automático",
        on: "ACTIVADO",
        off: "DESACTIVADO",
        notEnrolled: "No Esta Inscrito en Autopay",
        enrolled: "Inscrito en Autopay",
        enrollButtonText: "Inscribirse",
        manageButtonText: "Administrar",
    },
    button: {
        back: "ATRÁS",
        save: "GUARDAR",
        cancel: "CANCELAR",
        close: "CERRAR",
        paymentOptions: "Ver Opciones de Pago",
        paymentPlan: "Ver el Plan de Pagos ",
    },
    predelivery: {
        title: "Su préstamo está aprobado, pero aún se está procesando",
        subTitle: "Los detalles del préstamo se le proveerán cuando estén disponibles.",
    },
    error: {
        title: "Algo salió mal.",
        subTitle: "Por favor, actualice la página para volverlo a intentar.",
        error: "Error",
    },
    loanPaidOff: {
        title: "Este préstamo ya está saldado.",
        heading: "No tiene pagos pendientes en este momento.",
        subHeading: "Si tiene preguntas sobre su cuenta, por favor comuníquese con Servicio al Cliente (1-866-220-9432) durante el horario de atención.",
    },
};
export default es;
//# sourceMappingURL=es.js.map